var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 210,
    viewBox: "0 0 180 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 210,
    rx: 6,
    fill: "#5E6062"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    transform: "translate(56 71)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.804 96.4717L109.833 99.3475V124.833C109.833 126.336 109.236 127.778 108.173 128.84C107.11 129.903 105.669 130.5 104.166 130.5H75.8327C74.3298 130.5 72.8884 129.903 71.8257 128.84C70.763 127.778 70.166 126.336 70.166 124.833V85.1667C70.166 83.6638 70.763 82.2224 71.8257 81.1597C72.8884 80.097 74.3298 79.5 75.8327 79.5H90.7785C92.1073 79.5 93.3908 79.9647 94.4108 80.8147L108.787 92.8167C109.43 93.355 109.804 94.1512 109.804 94.9927V96.4688V96.4717ZM90.056 85.1667L89.9993 94.2107C89.999 94.5802 90.0716 94.9462 90.2131 95.2876C90.3546 95.629 90.5622 95.939 90.8239 96.2C91.0856 96.4609 91.3963 96.6675 91.7381 96.808C92.0799 96.9484 92.4461 97.02 92.8157 97.0185H104.149L90.056 85.1667Z",
    fill: "#8C8D8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBackdrop);
export default __webpack_public_path__ + "static/media/fileBackdrop.6cc259daf56bb5c5dc8b2a585b5c01cf.svg";
export { ForwardRef as ReactComponent };